import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { LOCAL_STORAGE_TOKENS } from "../utils/constants";

export default function AlertDialog({ setShowPopup, showPopup, navigateLink }) {
  const { localKey_selectedClient, localKey_userData } = LOCAL_STORAGE_TOKENS;
  const handleClose = () => {
    localStorage.removeItem(localKey_selectedClient);
    localStorage.removeItem(localKey_userData);
    navigateLink();
    setShowPopup(false);
  };

  return (
    <React.Fragment>
      <Dialog
        open={showPopup}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Session Expired...!"}
        </DialogTitle>
        <DialogActions>
          <Button variant="contained" onClick={handleClose}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
